'use client';

import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

export const useBreakpoint = () => {
  const [mounted, setMounted] = useState(false);
  const isXs = useMediaQuery({ maxWidth: 639 }); // <sm
  const isSm = useMediaQuery({ minWidth: 640 }); // >=sm
  const isMd = useMediaQuery({ minWidth: 768 }); // >=md
  const isLg = useMediaQuery({ minWidth: 1024 }); // >=lg
  const isXl = useMediaQuery({ minWidth: 1280 }); // >=xl
  const is2Xl = useMediaQuery({ minWidth: 1536 }); // >=2xl

  const isBelowSm = useMediaQuery({ maxWidth: 639 }); // <sm
  const isBelowMd = useMediaQuery({ maxWidth: 767 }); // <md
  const isBelowLg = useMediaQuery({ maxWidth: 1023 }); // <lg
  const isBelowXl = useMediaQuery({ maxWidth: 1279 }); // <xl
  const isBelow2Xl = useMediaQuery({ maxWidth: 1535 }); // <2xl

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted
    ? {
        isXs,
        isSm,
        isMd,
        isLg,
        isXl,
        is2Xl,
        isBelowSm,
        isBelowMd,
        isBelowLg,
        isBelowXl,
        isBelow2Xl
      }
    : {
        isXs: false,
        isSm: false,
        isMd: false,
        isLg: false,
        isXl: false,
        is2Xl: false,
        isBelowSm: false,
        isBelowMd: false,
        isBelowLg: false,
        isBelowXl: false,
        isBelow2Xl: false
      };
};
